export const guestCartConstants = {
    CART_PROCESS_START: 'guest:start',
    CART_PROCESS_STOP: 'guest:stop',
    CART_LIST: 'guest:list',
    CART_ADD: 'guest:add',
    CART_UPDATE: 'guest:update',
    CART_REMOVE: 'guest:delete',
    CART_REMOVE_All: 'guest:delete:all',
    CART_CLEAR: 'guest:clear',
}